// Version : 1.0.0
// Author : AGALYA

const PassportActionType = {
	/** ***************** Passport Update Start ************************/
	UPDATE_PASSPORT_START: 'update_passport_start',
	UPDATE_PASSPORT_SUCCESS: 'update_passport_success',
	UPDATE_PASSPORT_FAILURE: 'update_passport_failure',
	UPDATE_PASSPORT_RESPONSE_REST_START: 'update_passport_response_reset_start',
	UPDATE_PASSPORT_RESPONSE_CHANGED: 'update_passport_response_changed',

	/** ***************** Passport Update End ************************/
};

export default PassportActionType;
